import { TaggedError } from "@for-it/domain-lib";
export class PasswordRepeatError extends TaggedError {
    constructor() {
        super("PasswordRepeatError");
    }
}
